import { useState } from "react";
import { toast } from "shared/ui/shadcn/sonner";

import { useEffectOnce } from "../hooks";

interface UseIsNavigatorOnlineI {
  showToasts?: boolean;
}

// This hooks helps to track whether a consumer has an internet connection or not
export const useIsNavigatorOnline = (params?: UseIsNavigatorOnlineI) => {
  const shouldShowToasts = !!params?.showToasts;

  const [isOnline, setIsOnline] = useState(true);

  useEffectOnce(() => {
    const handleOnline = () => {
      if (shouldShowToasts) {
        toast.success("Connection restored!");
      }

      setIsOnline(true);
    };

    const handleOffline = () => {
      if (shouldShowToasts) {
        toast.error("Connection lost");
      }

      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  });

  return isOnline;
};
